import { InlineSvg } from 'components/svg';
import { NotificationWidget } from 'features/notifications';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeModeSwitcher } from 'theme/theme-mode-switcher';
import { toAbsoluteUrl } from 'utils/assets';

const Topbar: FC = () => {
  const navigate = useNavigate();
  return (
    <div className="d-flex flex-shrink-0 align-items-center flex-wrap gap-2 gap-sm-3">
      <div
        className="cursor-pointer d-flex"
        onClick={(e) => {
          e.preventDefault();
          navigate('/working-hours-tracking');
        }}
      >
        <img src={toAbsoluteUrl('/media/working-hours/working-hours.svg')} alt="Working hours" className="h-30px" />
      </div>
      <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center ms-sm-3 mt-2 mt-sm-0 gap-1 gap-sm-3">
        <div className="text-muted fs-7 fs-sm-5 fw-bold">
          <span className="d-inline d-sm-none">Duty Manager</span>
          <span className="d-none d-sm-inline">Online Duty Manager</span>
        </div>
        <span className="badge badge-light-primary fw-bolder">
          <InlineSvg path="/media/icons/duotune/arrows/arr097.svg" className="svg-icon svg-icon-1 svg-icon-primary" />
          Offline
        </span>
      </div>
      <div className="d-none d-sm-flex align-items-center ms-3">
        <ThemeModeSwitcher toggleBtnClass="flex-center bg-body btn-color-gray-600 btn-active-color-primary h-40px" />
      </div>
      <div className="d-sm-flex align-items-center ms-3">
        <NotificationWidget />
      </div>
    </div>
  );
};

export { Topbar };
